<div class="flex flex-auto">
    <p-autoComplete minLength="3" appendTo="body" [suggestions]="procedureSuggestions"  [(ngModel)]="procedure"
                        (completeMethod)="procedureSearch($event)" placeholder="Search Procedure" optionLabel="displayName"
                        class="m-2 flex flex-auto" styleClass="flex flex-auto" inputStyleClass="flex flex-auto" (onSelect)="selectProcedure($event)">
        <ng-template let-procedure pTemplate="item">
            <div class="flex align-items-center gap-2" >
                <div class="flex" >{{ procedure.code }} - {{procedure.description | slice : 0 : 100}}<span *ngIf="procedure.description.length > 100">...</span></div>
            </div>
        </ng-template>
    </p-autoComplete>
</div>